const ENDPOINT = "https://api.web3forms.com/submit";
const KEY = process.env.REACT_APP_WEB3FORMS_KEY;

/**
 * Submits form data to Web3Forms via a hidden iframe-targeted POST.
 *
 * Why iframe instead of fetch?
 * Some hosting environments (Cloudflare-fronted preview URLs, iframe'd
 * previews, COEP/CORP-restricted origins) block both regular `fetch` and
 * `no-cors` fetch to web3forms.com. A classic HTML form POST with
 * `target="_self"`-style hidden iframe is a "top-level navigation" that is
 * unaffected by CORS/CORP — the browser sends the POST, the email is
 * delivered, the opaque response loads into the throw-away iframe.
 *
 * We cannot read the response (cross-origin), so this is fire-and-forget.
 * The MongoDB backend write provides a permanent server-side record.
 */
export function sendToWeb3Forms(subject, fields) {
  return new Promise((resolve) => {
    if (!KEY) {
      resolve({ success: false, message: "Missing access key" });
      return;
    }

    const iframeName = `w3f-${Date.now()}`;
    const iframe = document.createElement("iframe");
    iframe.name = iframeName;
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    const form = document.createElement("form");
    form.action = ENDPOINT;
    form.method = "POST";
    form.target = iframeName;
    form.enctype = "multipart/form-data";
    form.style.display = "none";

    const addField = (name, value) => {
      if (value === undefined || value === null || String(value).length === 0)
        return;
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    };

    addField("access_key", KEY);
    addField("subject", subject);
    addField("from_name", "SANVIORO — web formulář");
    Object.entries(fields).forEach(([k, v]) => addField(k, v));

    document.body.appendChild(form);

    let settled = false;
    const finish = (ok) => {
      if (settled) return;
      settled = true;
      setTimeout(() => {
        form.remove();
        iframe.remove();
      }, 1500);
      resolve({ success: ok });
    };

    iframe.addEventListener("load", () => finish(true));
    // Safety fallback — assume success after timeout
    setTimeout(() => finish(true), 4500);

    form.submit();
  });
}
